import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  unverified: {
    defaultMessage: 'Unverified',
    id: 'ThirdPartyLabel.unverified',
  },
  unverifiedMessage: {
    defaultMessage:
      'This solution is made for development purposes only. Do not enter your bank credentials unless you trust the developer.',
    id: 'ThirdPartyLabel.unverifiedMessage',
  },
});
